"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationMatchPreviewDto = instanceOfOrientationMatchPreviewDto;
exports.OrientationMatchPreviewDtoFromJSON = OrientationMatchPreviewDtoFromJSON;
exports.OrientationMatchPreviewDtoFromJSONTyped = OrientationMatchPreviewDtoFromJSONTyped;
exports.OrientationMatchPreviewDtoToJSON = OrientationMatchPreviewDtoToJSON;
exports.OrientationMatchPreviewDtoToJSONTyped = OrientationMatchPreviewDtoToJSONTyped;
const ProfileWithAddresses_1 = require("./ProfileWithAddresses");
/**
 * Check if a given object implements the OrientationMatchPreviewDto interface.
 */
function instanceOfOrientationMatchPreviewDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    return true;
}
function OrientationMatchPreviewDtoFromJSON(json) {
    return OrientationMatchPreviewDtoFromJSONTyped(json, false);
}
function OrientationMatchPreviewDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ProfileWithAddresses_1.ProfileWithAddressesFromJSON)(json['nurseProfile']),
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'distanceMiles': json['distanceMiles'] == null ? undefined : json['distanceMiles'],
    };
}
function OrientationMatchPreviewDtoToJSON(json) {
    return OrientationMatchPreviewDtoToJSONTyped(json, false);
}
function OrientationMatchPreviewDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ProfileWithAddresses_1.ProfileWithAddressesToJSON)(value['nurseProfile']),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'distanceMiles': value['distanceMiles'],
    };
}
//# sourceMappingURL=OrientationMatchPreviewDto.js.map